<template>
  <transition :name="animation">
    <div class="pw_modal" v-if="isActive">
      <div class="pw_modal__overlay"></div>
      <div
        class="pw_modal__modal-content"
        ref="content"
        :style="{ width: newWidth + ' !important' }"
      >
        <div v-if="closeable" class="pw_modal__close" @click="close">
          <i class="mdi mdi-close"></i>
        </div>
        <component v-if="component" v-bind="props" v-on="events" :is="component" @close="close" />
        <div v-else-if="content" v-html="content"></div>
        <slot v-else />
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    active: Boolean,
    closeable: {
      type: Boolean,
      default: true,
    },
    component: [Object, Function],
    content: String,
    programmatic: Boolean,
    props: Object,
    events: Object,
    width: {
      type: [String, Number],
      default: 800,
    },
    hasModalCard: Boolean,
    animation: {
      type: String,
      default: 'zoom-out',
    },
    onCancel: {
      type: Function,
      default: () => {},
    },
    onClose: {
      type: Function,
      default: () => true,
    },
    size: String,
  },
  data() {
    return {
      isActive: this.active || false,
      contentHeigth: 0,
    };
  },
  beforeMount() {
    // this.programmatic && document.body.appendChild(this.$el);
  },
  updated() {
    this.getContentHeigth();
  },
  mounted() {
    if (this.programmatic) this.isActive = true;
    else if (this.isActive) {
    }

    this.getContentHeigth();
  },
  methods: {
    async close() {
      let canClose = true;

      if (this.onClose) {
        if (this.onClose.apply(null) && typeof this.onClose.apply(null).then === 'function') {
          canClose = await this.onClose.apply(null);
        } else {
          canClose =
            this.onClose.apply(null) === null || this.onClose.apply(null) === undefined
              ? true
              : this.onClose.apply(null);
        }
      }

      if (canClose) {
        this.$emit('close');
        this.$emit('update:active', false);
        if (this.programmatic) {
          this.isActive = false;
          setTimeout(() => {
            this.$destroy();
          }, 150);
        }
      }
    },
    getContentHeigth() {
      this.contentHeigth = 0;
    },
  },
  computed: {
    newWidth() {
      if (window.innerWidth <= 667) {
        return '95vw';
      }
      return typeof this.width === 'number' ? `${this.width}px` : this.width;
    },
  },
  watch: {
    active(value) {
      this.isActive = value;
    },
    // width(newValue) {
    //   this.newWidth = typeof newValue === "number" ? newValue + "px" : newValue;
    // },
  },
};
</script>

<style lang="scss">
.close-frame {
  margin-left: 10px;
  float: right;
  cursor: pointer;
  font-size: 170%;
  color: #a4afb7;
}
.pw_modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1001;
  &__close {
    font-size: 170%;
    position: absolute;
    top: 25px;
    right: 28px;
    cursor: pointer;
    z-index: 100;
    color: #a4afb7;
    &:hover {
      color: #848d94;
    }
  }
  &__body {
    overflow-y: auto;
    overflow-x: hidden;
    max-height: calc(80vh - 55px);
  }
  &__footer {
    overflow: visible;
    position: relative;
    bottom: 0px;
  }
  &__overlay {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    background-color: rgba(0, 0, 0, 0.3);
  }
  &__modal-content {
    padding: 24px;
    box-sizing: border-box;
    border-radius: 4px;
    background-color: #fff;
    min-height: 50px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    max-height: 580px;
    width: 800px;
    &.pw-modal__modal-content-overflow {
      max-height: 580px;
      overflow-y: auto;
    }
  }
}
</style>
